const Roles = {
    'Admin': 'Administrator',
    'Counsellor': 'Counsellor'
}

export default Roles;